import { DokumentVersandArt } from '@core/domain';
import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Select } from '@/components/ui/select';

interface VersandArtDialogProps {
  open: boolean;
  selectedVersandArt: DokumentVersandArt | '';
  isLoading: boolean;
  onOpenChange: (open: boolean) => void;
  onChange: (value: DokumentVersandArt | '') => void;
  onConfirm: () => void;
}

const versandArtOptions: { value: DokumentVersandArt; label: string }[] = [
  {
    value: DokumentVersandArt.POSTVERSAND,
    label: 'Dokument',
  },
  {
    value: DokumentVersandArt.EMAIL_OHNE_DOKUMENT,
    label: 'E-Mail',
  },
];

export const VersandArtDialog: React.FC<VersandArtDialogProps> = ({
  open,
  selectedVersandArt,
  isLoading,
  onOpenChange,
  onChange,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Art der Preview auswählen</DialogTitle>
          <DialogDescription>
            Bitte wählen Sie die Art der Preview aus, um eine Vorschau zu
            erzeugen.
          </DialogDescription>
        </DialogHeader>
        <Select
          value={
            selectedVersandArt === ''
              ? ''
              : String(selectedVersandArt as number)
          }
          onChange={(event) =>
            onChange(
              event.target.value === ''
                ? ''
                : (Number(event.target.value) as DokumentVersandArt),
            )
          }
          placeholder="Bitte wählen..."
          options={versandArtOptions.map((option) => ({
            value: String(option.value),
            label: option.label,
          }))}
        />
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Abbrechen
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={selectedVersandArt === '' || isLoading}
          >
            Weiter zur Vorschau
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
